import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';

interface NewsSidebarProps {
  items: NewsItem[];
}

export default function NewsSidebar({ items }: NewsSidebarProps) {
  return (
    <aside className="w-full lg:w-[360px] shrink-0">
      <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
          <h2 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
            <i className="ri-newspaper-line text-primary-500"></i> 热门剧情资讯
          </h2>
          <Link to="/news" className="text-xs text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap">
            全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <ul className="divide-y divide-background-200">
          {items.map((n) => (
            <li key={n.id}>
              <Link to="/news" className="block px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer group">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs font-medium text-accent-700 bg-accent-100 rounded-full px-2 py-0.5">{n.category}</span>
                  <span className="text-xs text-foreground-400">{n.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {n.title}
                </h3>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-5 rounded-lg bg-secondary-900 p-5">
        <h3 className="font-heading font-bold text-white text-lg">追剧日历</h3>
        <p className="mt-2 text-sm text-secondary-200 leading-relaxed">
          每周一至周四更新，热门剧集播出当天同步剧情解析与演员动态。
        </p>
        <Link
          to="/news"
          className="mt-4 inline-flex items-center gap-1 cursor-pointer whitespace-nowrap bg-white text-secondary-900 text-sm font-medium px-4 py-2 rounded-full hover:bg-secondary-100 transition-colors"
        >
          <i className="ri-calendar-event-line"></i> 查看本周更新
        </Link>
      </div>
    </aside>
  );
}